'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.themePropTypes = exports.styles = exports.modifierConfig = undefined;

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var modifierConfig = exports.modifierConfig = {
  colorText: function colorText(_ref) {
    var theme = _ref.theme;
    return {
      styles: 'color: ' + theme.colors.base.text + ';'
    };
  },
  colorTextLight: function colorTextLight(_ref2) {
    var theme = _ref2.theme;
    return {
      styles: 'color: ' + theme.colors.base.textLight + ';'
    };
  }
}; // These are common styles shared by our A and Link Elements.
// Keeping them consolidated will help ensure they stay in sync.
var styles = exports.styles = function styles(_ref3) {
  var theme = _ref3.theme;
  return '\n  color: ' + theme.colors.base.link + ';\n  cursor: pointer;\n  font-size: 12px;\n  text-decoration: none;\n  text-transform: capitalize;\n  white-space: nowrap;\n\n  &:hover {\n    color: ' + theme.colors.base.linkHover + ';\n    text-decoration: underline;\n    .fa {\n      color: ' + theme.colors.base.linkHover + ';\n    }\n  }\n';
};

var themePropTypes = exports.themePropTypes = {
  colors: _propTypes2.default.shape({
    base: _propTypes2.default.shape({
      link: _propTypes2.default.string.isRequired,
      linkHover: _propTypes2.default.string.isRequired,
      text: _propTypes2.default.string.isRequired,
      textLight: _propTypes2.default.string.isRequired
    }).isRequired
  }).isRequired
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/base-components/build/styles/common/Link.js
// module id = 713
// module chunks = 2